_theme.handleBundleATC = function() {
    if(jQuery('.cm-bundle-form-wrapper').length === 0) return;

    let formHTML = jQuery('.cm-bundle-form-wrapper').html();
    let addedBundleMes = jQuery('.addedMessageBundleText');
    
    jQuery(document).on('click touchstart','button.cm-add-bndle-pro',function(evt){
        evt.preventDefault();
        evt.stopPropagation();
        const $self = jQuery(this);

        jQuery(this).addClass('click-processing').attr('disabled', true);
        jQuery('.cm-bundle-form-wrapper form').remove();
        jQuery(this).after(formHTML);

        const varID = jQuery(this).closest('.bundle-proItem').find('span.variant.cmVariant').attr('data-id');
        jQuery('form#add-to-cart-quickview-form input[name="id"]').val(varID);
        jQuery('form#add-to-cart-quickview-form input[name="quantity"]').attr('data-qv-qtt-id',"quantity__"+varID);

        const $statusAnnounceElem = jQuery(this).parent().find(addedBundleMes);
        _theme.toggleLoading(1);
        $statusAnnounceElem.text("Please wait, adding product to the cart");

        // Do Not Remove Code - Add Properties for GWP Discount
        let properties = {};
        let bundleVarIdElement = $self.closest(".grid-item").find("[data-bundleVarId]");
        if (bundleVarIdElement.length > 0) {
            properties["_bundleVarId"] = bundleVarIdElement.val() || null;
        }
        // Do Not Remove Code - Add Properties for GWP Discount

        _theme.Helpers.addProductToCart(varID,1,properties, function(resp){
        _theme.MiniCart.lineItemChangeCallBack(resp, function(){
            $statusAnnounceElem.text('item added to your cart successfully');
            _theme.toggleLoading();
            _theme.toggleSideCart(1, $self, true);
            
            jQuery('form#add-to-cart-quickview-form').remove();
            $self.removeAttr('disabled');
            $self.removeClass('click-processing');
        });
        }, function(err){
        console.error(err)
        });
    });
}

jQuery(document).ready(function() {
  _theme.handleBundleATC();
});

// Remove any existing listeners first to prevent duplicate handlers
jQuery(document).off('click.preview-atc', 'button.preview-atc-btn').on('click.preview-atc','button.preview-atc-btn',function(evt) {
  evt.preventDefault();
  evt.stopPropagation();
  evt.stopImmediatePropagation();

  const $self = jQuery(this);

  // Prevent double-firing: check if already processing using multiple methods
  if ($self.hasClass('click-processing') ||  $self.attr('disabled') || $self.data('atc-processing') === true) {
    return false;
  }

  // Mark as processing immediately
  $self.data('atc-processing', true);
  $self.addClass('click-processing').attr('disabled', true);

  let qty = $self.closest('form').find('.quantity__select [data-quantity-select]').val();
  const varID = $self.closest('[data-grid-inner]').find('[data-preview-var-id]').data('preview-var-id');
  const $statusAnnounceElem = $self.parent().find('.addedMessageBundleText');
  $statusAnnounceElem.text("Please wait, adding product to the cart");

  if (qty === undefined || qty === null || qty === "" || isNaN(parseInt(qty))) {
    qty = 1;
  } else {
    qty = parseInt(qty);
  }

  // Do Not Remove Code - Add Properties for GWP Discount
  let properties = {};
  let bundleVarIdElement = $self.closest(".grid-item").find("[data-bundleVarId]");
  if (bundleVarIdElement.length > 0) {
      properties["_bundleVarId"] = bundleVarIdElement.val() || null;
  }
  // Do Not Remove Code - Add Properties for GWP Discount

  _theme.toggleLoading(1);
  _theme.Helpers.addProductToCart(varID,qty,properties, function(resp){
    _theme.MiniCart.lineItemChangeCallBack(resp, function(){
      $statusAnnounceElem.text('Item added to your cart successfully');
      _theme.toggleLoading();
      _theme.toggleSideCart(1, $self, true);

      $self.closest('[data-grid-inner]').find('.preview-size-qv').removeClass('active');
      $self.closest('[data-grid-inner]').find('[data-grid-inner-top]').removeClass('hidden');
      $self.closest('[data-grid-inner]').find('[data-preview-size-grid]').addClass('hidden');

      // Reset all processing flags
      $self.removeAttr('disabled');
      $self.removeClass('click-processing');
      $self.removeData('atc-processing');
    });
  }, function(err){
    console.error(err)
    // Reset processing flags on error too
    $self.removeAttr('disabled');
    $self.removeClass('click-processing');
    $self.removeData('atc-processing');
  });
});